import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { ArrowIcon, HexIcon, OuterIcon } from "src/components/icons";

type PropsType = {
  text: string;
  variant?: "filled" | "outlined";
  onClick?: () => void;
};

export const AnimatedBlueButton: React.FC<PropsType> = ({ text, variant = "filled", onClick }) => {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <Box
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "clamp(10px,.729vw,14px)",
        cursor: "pointer",
        width: "fit-content",
        textDecoration: "none",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: 52,
          height: 48,
          overflow: "hidden",
          svg: {
            ":nth-of-type(1)": {
              path:
                variant === "filled"
                  ? { fill: "#0058dd" }
                  : {
                      fill: "none",
                      stroke: "#0058dd",
                      strokeWidth: "2px",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                    },
            },
            ":nth-of-type(2)": { path: { fill: variant === "filled" ? "white" : "#0058dd" } },
          },
        }}
      >
        {variant === "filled" ? (
          <HexIcon sx={{ width: 52, height: 48, opacity: isHovering ? 0.95 : 1, transition: "opacity 0.3s" }} />
        ) : (
          <OuterIcon sx={{ width: 52, height: 48, opacity: isHovering ? 0.95 : 1, transition: "opacity 0.3s" }} />
        )}
        <ArrowIcon
          sx={{
            width: "62px",
            height: "58px",
            transform: isHovering ? "translate(85%, -82%)" : "translate(0)",
            transition: "transform .3s ease-in-out",
            position: "absolute",
            top: "19px",
            right: "21px",
          }}
        />
      </Box>
      <Typography sx={{ letterSpacing: ".04em", fontSize: "clamp(14px,.833vw,16px)", fontWeight: "500", lineHeight: 1.4 }}>
        {text}
      </Typography>
    </Box>
  );
};
export default AnimatedBlueButton;
